import store from './store'; 
import { saveUserData } from './actions';

const updateUserData = (userId:string, payload:any, isConnected: boolean) => {
  store.dispatch(saveUserData(userId, payload, isConnected));
};

export default updateUserData;
